import { styled } from '@mui/material';
import { ReactComponent as IconOffice } from '../../../assets/images/office.svg';

export const IconOfficeComponent = styled(IconOffice)(() => ({
  height: '24px',
  width: '24px',
  color: 'currentColor',
  cursor: 'pointer',
}));
